import { useEffect, useState } from 'react'
import { Button } from '@design-systems/canvas-ui'
import Icon, { TimeClockIcon } from '@design-systems/react-icons'

const getRemainingSeconds = (endsAt) =>
  Math.max(0, Math.ceil((endsAt - Date.now()) / 1000))

// Shown on the setting-up profile while the backend still holds the
// publication back. Counts down to `endsAt`, so leaving the tab and coming
// back picks up where the clock really is.
const PublishUndoNotice = ({ endsAt, isCancelling, onCancel, onExpire }) => {
  const [remaining, setRemaining] = useState(() => getRemainingSeconds(endsAt))

  useEffect(() => {
    const timer = setInterval(
      () => setRemaining(getRemainingSeconds(endsAt)),
      500,
    )
    return () => clearInterval(timer)
  }, [endsAt])

  useEffect(() => {
    if (remaining <= 0) onExpire()
  }, [onExpire, remaining])

  return (
    <div className="publish-undo-notice" role="status">
      <span className="publish-undo-notice__timer">
        <Icon size="sm" svg={TimeClockIcon} /> {remaining}s
      </span>
      <span className="publish-undo-notice__message">
        <strong>Publishing started.</strong> You can still cancel it.
      </span>
      <Button isLoading={isCancelling} onClick={onCancel} variant="secondary">
        Cancel publishing
      </Button>
    </div>
  )
}

export default PublishUndoNotice
